const orgIdsShowEditCost = [2]

export {orgIdsShowEditCost}
